import * as actions from './actions'

const initState = {
    sharedUsers: null,
    locations: null,
    devices: null,
    reports: null,
    selectedSharedUsers: [],
    selectedLocations: [],
    selectedDevices: [],
    selectedReports: [],
    isSharingSuccess: false
}

export default function reducer(state = initState, action) {
    switch(action.type) {
        case actions.LOCATIONS_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    locations: action.locations
                }
            }
        case actions.DEVICES_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    devices: action.devices
                }
            }
        case actions.REPORTS_REQUEST_SUCCESS:
            return {
                ...state,
                ...{
                    reports: action.reports
                }
            }
        case actions.SHARED_USERS_SUCCESS:
            return {
                ...state,
                ...{
                    sharedUsers: action.sharedUsers
                }
            }
        case actions.SET_SELECTED_SHARED_USERS:
            return {
                ...state,
                ...{
                    selectedSharedUsers: action.selectedSharedUsers
                }
            }
        case actions.SET_SELECTED_LOCATIONS:
            return {
                ...state,
                ...{
                    selectedLocations: action.selectedLocations
                }
            }
        case actions.SET_SELECTED_DEVICES:
            return {
                ...state,
                ...{
                    selectedDevices: action.selectedDevices
                }
            }
        case actions.SET_SELECTED_REPORTS:
            return {
                ...state,
                ...{
                    selectedReports: action.selectedReports
                }
            }
        case actions.SHARE_SUCCESS:
            return {
                ...state,
                ...{
                    isSharingSuccess: true
                }
            }
        case actions.SHARE_ERROR:
            return {
                ...state,
                ...{
                    isSharingSuccess: false
                }
            }
        default:
            return state
    }
}